<template>
    <div :class="['result', 'container', loading ? 'loadingResults' : '']"  @scroll="onScroll">

        <div class="tabs">
            <div :class="['tab-button', { active: activeView === 'products' }]" @click="activeView = 'products'">
                {{this.$root.language.wsm_CO_products}} <span class="resultCount">{{result.products.length}}</span>
            </div>
            <div :class="['tab-button', { active: activeView === 'articles' }]" @click="activeView = 'articles'">
                {{this.$root.language.wsm_relatedArticles}} <span class="resultCount">{{result.articles.length}}</span>
            </div>
            <div :class="['tab-button', { active: activeView === 'videos' }]" @click="activeView = 'videos'">
                {{this.$root.language.wsm_videos}} <span class="resultCount">{{result.videos.length}}</span>
            </div>
        </div>
        <div>
            <div v-if="result.products.length > 0 && activeView == 'products'" class="products" >
                <div>
                    <a v-for="productInfo in result.products" :key="productInfo.sortNo" :href="basedir+'/'+productInfo.productPageLink">
                    
                        <div :key="productInfo.sortNo" class="prodContainer" >
                            <div class="prodImg" >
                                <img :src="`${fetchImageUrl(productInfo.imageUrl, productInfo.name)}?w=10&quality=1`" :srcset="imageSet(fetchImageUrl(productInfo.imageUrl, productInfo.name)).set" >
                            </div>
                                <div class="prodInfo" >
                                    <div class="prodHeader">
                                        <h5 v-html="truncateString(productInfo.name, 50)" ></h5>
                                        <span v-if="productInfo.promotionAttributes.length" class="promo">
                                            {{productInfo.promotionAttributes[0].name}}
                                        </span>
                                    </div>
                                    <div class="quantString" v-html="productInfo.quantityString"></div>
                                    <p v-html="truncateString(productInfo.description.replace('<br>', ''), 100)"></p>
                                    <p  v-if="$root.isWebshop" class="price">{{getPrice(productInfo.price, productInfo.CurrencyIso, productInfo.currencyPrecision, productInfo.locale)}}</p>
                                    <div  v-if="$root.isWebshop" class="additionalInfo">
                                        <p v-if="productInfo.discount > 0">
                                            <span class="strikedPrice">{{getPrice(productInfo.listPrice, productInfo.CurrencyIso, productInfo.currencyPrecision, productInfo.locale)}}</span> {{$root.language.wsm_YouSave}} {{getPrice(productInfo.discount, productInfo.CurrencyIso, productInfo.currencyPrecision, productInfo.locale)}}
                                        </p>
                                        <p v-if="$root.iscompany && productInfo.taxRateFactor > 1" class="inclVat">{{$root.language.wsm_InclVAT}} {{getPrice(productInfo.companyPriceIncludingVat, productInfo.CurrencyIso, productInfo.currencyPrecision, productInfo.locale)}}</p>
                                    </div>
                                </div>
                        </div>
                    </a>
                </div>
            </div>
            <div v-if="result.products.length == 0 && activeView == 'products'">
                <p class="noResult">{{this.$root.language.wsm_noResult}}</p>
            </div>
            <div v-if="result.articles.length > 0  && activeView == 'articles'" class="articles">
                        <a class="articlesWrapper" v-for="(article, index) in result.articles" :key="index" :href="basedir+article.urlPrefix+article.url">
                                <div class="articleContainer">
                                    <img :src="article.imageUrl.indexOf('http') >= 0 ? article.imageUrl : basedir+article.imageUrl">
<!--                                     <div class="newsImg" v-bind:style="{backgroundImage: '-webkit-image-set('+imageSetCSS(article.imageUrl.indexOf('http') >= 0 ? article.imageUrl : basedir+article.imageUrl).set+')'}"></div>
 -->                                    <div class="articleInfo">
                                        <h5>{{truncateString(article.headers, 40)}}</h5>
                                        <p v-html="truncateString(article.description, 100)"></p>
                                    </div>
                                </div>
                        </a>
            </div>
            <div v-if="result.articles.length == 0 && activeView == 'articles'">
                <p class="noResult">{{this.$root.language.wsm_noResult}}</p>
            </div>
            <div v-if="result.videos.length > 0 && activeView == 'videos'" class="videos">
                        <div class="videoSlide" v-show="show" v-for="(video, index) in result.videos" :key="index" @click="$refs['ytplayer_'+video.id][0].openVideo('', video.id)">
                            <video-container :useLazy="false" :index="index" :video="video" :numberOfCharacters="40"></video-container>
                            <!-- <div class="videoContainer">
                                <div class="newsImg"><img :src="video.snippet.thumbnails.medium.url"></div>
                                <p class="title"><span class="play"><i class="fas fa-play"></i></span><span class="titleText">{{truncateString(video.snippet.title.replace(' | Pharma Nord', ''), 40)}}</span></p>
                            </div> -->
                        </div>
            </div>
            <div v-if="result.videos.length == 0 && activeView == 'videos'">
                <p class="noResult">{{this.$root.language.wsm_noResult}}</p>
            </div>
        </div>
        <div v-for="(video, index) in result.videos" :key="index">
            <!-- <youtubeplayer :ref="'ytplayer_'+video.id" :videoFromUrl="{status: true, data: video}"></youtubeplayer> -->
            <!-- <youtubeplayer2 :ref="'ytplayer_'+video.id" :videoData="video" :videoDataStatus="true" :playListArray="[]" :key="index"></youtubeplayer2> -->
            <youtubeplayer3 :ref="'ytplayer_'+video.id" :videoData="video" :videoDataStatus="true" :playListArray="[]" :key="index"></youtubeplayer3>
        </div>
    </div>
</template>
<script>
//import youtubeplayer from '../../../globalComponents/youtubeplayer.vue'
import youtubeplayer3 from '../../../globalComponents/youtubeplayer3.vue'
import videoContainer from '../../../youtubewidget/src/components/videoContainer.vue'
import priceHandler from '../../../globalComponents/visualFormattingForPrices';
import * as Bowser from "bowser";
  const fallBackBrowserVersions = {
    Chrome: 31,
    Edge: 17,
    Safari:15.6,
    Firefox: 64,
    Opera:18,
    AndriodBrowser: 4.1,
    KaiOSBrowser:2.5
  };
export default {
    name: 'result',
    props: ["result", "loading", "showLoader"],
    components: { youtubeplayer3, videoContainer },
    data() {
        return {
            show: false,
            imageSrcSets: [1, 1.3, 1.6, 2, 2.5, 2.8, 3],
            imageSize: 208.75,
            newsImageSize: 240,
            activeView: 'products',
            limits: {
                products: 3,
                videos: 3,
                articles: 3,
            },
        }
    },
    created() {

    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.show = true;
            }, 100)
        });
    },
    methods: {
        onScroll() {
      this.$emit('scroll');
    },
        getPrice(price, currencyIso, currencyPrecision, locale) {
            return priceHandler.visualFormattingForPrices(price, currencyIso, currencyPrecision, locale)
        },
        fetchImageUrl (url, name){
            const imageParams = {
                url : url,
                flap : "M",
                fileExtension : this.isBrowserCompatableForWebPImages,
                size : "",
            };
            function isValidUrl(url) {
                return ["http://", "https://"].some(protocol => url.startsWith(protocol));
            }
            function fetchImage(imageId, imageParams) {
                return `${basedir}/productImageServlet/${imageId}${imageParams.flap}.${imageParams.size}.${imageParams.fileExtension}`;
            }
            const isValidUrls = isValidUrl(imageParams.url);
            if (isValidUrls) {  
                const reg = /.+?:\/\/.+?(\/.+?)(?:#|\?|$)/;
                const pathname = reg.exec(imageParams.url)[1];
                const pathArray = pathname.split("/");
                const imageLInk = pathArray.length > 1 ? pathArray[2] : pathArray[1];
                const imageIdArray = imageLInk.split(".");
                const imageId = imageIdArray[0];
                if(isNaN(+imageId)){
                    return  imageParams.url;
                }else{
                    imageParams.size = imageIdArray[1]? imageIdArray[1] : "th3" ;
                    return  fetchImage(`ID${imageId}`, imageParams);
                }
            }else if((/((^ID|SKU)\d+|(^ID|SKU)\d+\.th\d.png)$/i).test(imageParams.url)){
                const imageIdArray = imageParams.url.split(".");
                const imageId = imageIdArray[0];
                imageParams.size = imageIdArray[1]? imageIdArray[1] : "th3" ;
                return fetchImage(imageId, imageParams);  
            }else {
                return  imageParams.url;
            }
        },
        showMore(val) {
            this.result[val].forEach(item => {
                item.show = true;
            })
        },
        truncateString(str, num) {
            if (typeof str != 'undefined') {
                if (str.length <= num) {
                    return str
                }
                return str.slice(0, num) + '...'
            } else {
                return '';
            }
        },
        handleSlideClick(val) {
            window.location = val;
        },
        imageSet: function(url) {
            var mode = 'x' //w, x
            var returnObj = {}
            var sizeAttr = [];
            var srcString = '';
            this.imageSrcSets.forEach((size, index) => {
                switch (mode) {
                    case 'x':
                        srcString += url + '?w=' + Math.floor(this.imageSize * size) + '&quality=100 ' + size + 'x' + ((index + 1) == this.imageSrcSets.length ? '' : ', ')
                        return {
                            set: srcString,
                            size: ''
                        };
                        break;
                    case 'w':
                        srcString += url + '?w=' + Math.floor(this.imageSize * size) + ' ' + Math.floor(this.imageSize * size) + 'w' + ((index + 1) == this.imageSrcSets.length ? '' : ', ')
                        sizeAttr.push(Math.floor(this.imageSize * size))
                        break;
                }
            })
            returnObj["set"] = srcString;
            if (mode == 'w') {
                returnObj["size"] = sizeAttr;
            } else {
                returnObj["size"] = '';
            }
            return returnObj
        },
        imageSetCSS: function(url) {
            var mode = 'x' //w, x
            var returnObj = {}
            var sizeAttr = [];
            var srcString = '';
            this.imageSrcSets.forEach((size, index) => {
                switch (mode) {
                    case 'x':
                        srcString += 'url(' + url + '?w=' + Math.floor(this.newsImageSize * size) + '&quality=100) ' + size + 'x' + ((index + 1) == this.imageSrcSets.length ? '' : ', ')
                        return {
                            set: srcString,
                            size: ''
                        };
                        break;
                    case 'w':
                        srcString += url + '?w=' + Math.floor(this.newsImageSize * size) + ' ' + Math.floor(this.newsImageSize * size) + 'w' + ((index + 1) == this.imageSrcSets.length ? '' : ', ')
                        sizeAttr.push(Math.floor(this.newsImageSize * size))
                        break;
                }
            })
            returnObj["set"] = srcString;
            if (mode == 'w') {
                returnObj["size"] = sizeAttr;
            } else {
                returnObj["size"] = '';
            }
            return returnObj
        },
        removeCarouselDotTitle(){
           /*  const el = document.getElementsByClassName('VueCarousel-dot')
            //console.log(el, "El Dot");
            if(document.getElementsByClassName('VueCarousel-dot').length) {
                el.forEach(element =>{
                    //console.log(element, "element")
                    element.removeAttribute("title");
                })
            } */
        }
    },
    computed: {
        isBrowserCompatableForWebPImages(){
            return Number(Bowser.version) > fallBackBrowserVersions[Bowser.name]? "webp" : "png";
        },
        basedir() {
            return window.basedir;
        }
    },
    watch: {
        loading(newVal, oldVal){
            if(oldVal && !newVal){
                this.$nextTick(()=>{
                    this.removeCarouselDotTitle();

                })
            }
        }
    }
}
</script>
<style scoped lang="scss">
.result {
    width: 60%;
    padding: 20px;
    border-radius: 5px;
    display: block;
    margin: 0 auto;
    margin-top: 10px;
    box-shadow: 0 0 20px 2px #0000004d;
    max-height: 70vh;
    overflow: scroll;
    overflow-x: hidden;
    position: absolute;
    background: white;
    z-index: 999;
    right: 0;
    left: 0;
    overscroll-behavior: contain;
    hr {
        margin-bottom: 22px;
        margin-top: 22px;
        width: 80%;
    }
    .tabs {
        width:100%;
        display: flex;
        justify-content: space-between;
        .tab-button {
            background: #ffffff;
            width: 100%;
            cursor:pointer;
            display: flex;
            justify-content: center;
            border: 1px solid #304145;
            padding: 0.5rem;
            align-items: center;
            font-weight: bold;
            font-size: 1.6ch;
            gap: 0.4rem;
            text-transform: uppercase;
            &:first-child {
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
            }
            &:not(:last-child) {
                border-right: none;
            }
            &:last-child {
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
            }
            &.active {
                background: #304145;
                color: white;
                .resultCount {
                    background: white;
                    color: #2e4145;
                }
            }
        }
    }
}
.showMoreSearchResults {
    width: 100%;
    padding: 9px;
    font-size: 1em;
    font-weight: bold;
    background: #2e4145;
    border: 0;
    cursor: pointer;
    color: white;
    &:hover {
        background: #3d575c;
    }
}
.articles {
    display: grid;
    align-content: center;
    justify-items: center;
    grid-template-columns: auto auto;
    .articlesWrapper {
        display: grid;
    align-content: center;
    justify-items: center;
    grid-template-columns: auto auto;
    }
}
.resultCount {
    background: #2e4145;
    color: white;
    border-radius: 32px;
    width: auto;
    display: inline-block;
    text-align: center;
    vertical-align: text-top;
    padding: 0px;
    padding-top: 1px;
    line-height: 26px;
    font-weight: normal;
    min-width: 22px;
    height: 22px;
    font-size: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.products,.videos {
    width: 100%;
    vertical-align: top;
    display: block;
    margin-bottom: 10px;
    clear: both;
}
.videos {
    display: grid;
    align-content: center;
    justify-items: center;
    grid-template-columns: auto auto;
    gap: 1rem;
    margin-top: 1rem;
}
.prodContainer {
    display:flex;
    gap: 0.5rem;
    margin: 11px 0px;
    transition: all 0.1s ease-in-out;
    border-bottom: 1px solid #e5e5e5;
    cursor: pointer;
    padding: 14px 0px;
    
    h5 {
        color: #2e4145;
        min-height: auto;
    }
}
.noResult {
    width: 100%;
    font-size: 2em;
    margin-top:2rem;
    text-align: center;
}
.videoSlide{
    box-sizing: border-box;
    padding: 5px;
}
.articleContainer {
    margin-right: 25px;
    background: #f2f2f2;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
    border-radius: 4px;
    width: 92%;
    border: 1px solid #d9d9d9;
    display: block;
    vertical-align: top;
    margin: 11px;
    min-height: 206px;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    &:hover {
        transform: scale(1.02);
    }
    img {
        width: 100%;
    }
    overflow: hidden;
    .articleInfo {
        min-height: 90px;
        background: white;
        margin-top: -4px;
        padding: 7px;
        h5 {
            font-size: 0.8em;
            font-family: inherit;
            padding: 6px;
            padding-bottom: 0;
            color: black;
        }
        p {
            padding: 6px;
            padding-top: 0;
            font-family: inherit;
            color: black;
        }
    }
    .newsImg {
        height: 146px;
        background-position: center;
        background-size: cover;
        img {
            width: 100%;
        }
    }
}
.hide {
    display: none;
}
.prodImg {
    display: inline-block;
    width: 30%;
    // margin-right:0.5rem;
    vertical-align: top;
    img {
        width: 100%;
        image-rendering: auto;
        image-rendering: crisp-edges;
        image-rendering: pixelated;
        image-rendering: optimizespeed;
        display:block;
        margin:0 auto;
    }
}
.prodInfo {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
    .strikedPrice {
        text-transform: line-through;
        font-size: 12px;
        text-decoration: line-through;
    }
    div.quantString {
        font-size: 14px !important;
        font-weight: bold !important;
        color: #5a7d9c !important;
        p {
            font-size: 14px !important;
            font-weight: bold !important;
            color: #5a7d9c !important;
        }
    }
    div.quantString p {
        font-size: 14px !important;
        font-weight: bold !important;
        color: #5a7d9c !important;
    }
    .prodHeader {
        display:flex;
        gap:0.5rem;
        align-items: flex-start;
        position: relative;
        .promo {
            background:orange;
            padding-left: 5px;
            padding-right: 5px;
            color: white;
            border-radius: 4px;
            font-size: 12px;
        }
    }
    .price {
        font-weight: bold;
        color:#004570;
        font-size: 1rem;
    }
}
h4 {
    font-size: 1.5em;
    font-weight: bold;
    margin-bottom: 10px;
    text-transform: capitalize;
    color: #2e4145;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.loading {
    width: 100%;
    height: 100%;
    min-width: 75%;
    min-height: 300px;
    font-weight: bold;
    font-size: 3em;
    overflow: hidden;
    .fa-pulse {
        text-align: center;
        font-size: 3em;
        top: 26%;
        position: absolute;
        color: #2e414585;
        right: 0;
        left: 0;
    }
}
@media screen and (max-width: 499px){
    #globalsearch .result .tabs{
        flex-direction: column;
        .tab-button{
            border-radius: 5px;
        }
        .tab-button:not(:last-child){
            border-right: 1px solid #304145;
        }
    }

    .prodContainer .prodImg{
        width: 50%;
    }
    
    .prodHeader .promo{
        position: absolute;
        right: 0px;
        top: -15px;
    }

    .result .articles, .result .videos{
        grid-template-columns: auto;
    }
    
}
</style>

<style lang='scss'>
.prodInfo p,
.articleInfo p {
    font-size: 12px;
    margin: 0;
}
.prodInfo{
    .quantString p {
        font-size: 14px;
            font-weight: bold;
            color: #5a7d9c;
    }
     p {
        margin:0;
        i, em{
            background-color: #88aeb7;
            padding: 3px 5px;
            color: white;
           // margin: 4px 0;
            border-radius: 10px;
            display: block;
            font-size:11px;
            display:none;
        }
    }
}
.VueCarousel-dot-container {
    margin-top: 15px !important;
}

.VueCarousel-dot {
    margin-top: 0 !important;
    background-color: #2e4145ad !important;
}

.VueCarousel-dot--active {
    background-color: #2e4145 !important;
}

</style>